// src/App.js - File principale dell'applicazione
import React from 'react';
import SensorDashboard from './components/SensorDashboard';
import WeatherStation from './components/WeatherStation';
import ErrorBoundary from './components/ErrorBoundary';
import './App.css';

function App() {
  return (
    <div className="App min-vh-100 bg-light d-flex flex-column">
      <header className="bg-primary text-white py-2 px-3 shadow-sm fixed-top d-flex justify-content-between align-items-center">
        <h1 className="fs-5 fw-bold mb-0">Dashboard Sensori</h1>
        <span className="text-white-50 small">Monitoring</span>
      </header>
      
      <main className="container-fluid py-2 mt-5 mb-4 flex-grow-1">
        {/* Weather Station Component */}
        <ErrorBoundary>
          <section className="mb-4">
            <WeatherStation />
          </section>
        </ErrorBoundary>
        
        {/* Sensor Dashboard */}
        <ErrorBoundary>
          <section>
            <SensorDashboard />
          </section>
        </ErrorBoundary>
      </main>

      {/* Pulsante globale a fine pagina per impostare gli allarmi */}
      <footer className="bg-white border-top py-3 mt-auto">
        <div className="container-fluid d-flex justify-content-end">
          <a
            href="/sensori/impostaallarmi.php"
            className="btn btn-outline-primary btn-sm"
          >
            <i className="bi bi-gear me-1"></i> Imposta Allarmi
          </a>
        </div>
      </footer>
    </div>
  );
}

export default App;